import { useLocalSearchParams, useRouter } from "expo-router";

import { ScreenLayout } from "@/blocks/ScreenLayout";
import { WorkRequirementsTitle } from "@/blocks/WorkRequirementsTitle";
import { VnBox } from "@/components/VnBox";
import { VnButton } from "@/components/VnButton/VnButton";
import { VnLoadingSpinner } from "@/components/VnLoadingSpinner";
import { VnText } from "@/components/VnText/VnText";
import { useGetWorkRequirementQuery } from "@/data/queries/workRequirementsQueries";

import { WorkRequirementMembersNextSteps } from "./WorkRequirementMembersNextSteps";

export const WorkRequirementDetailScreen = () => {
  const router = useRouter();
  const { id } = useLocalSearchParams<{ id: string }>();
  const { data: workRequirement, isPending } = useGetWorkRequirementQuery(id);

  if (isPending || !workRequirement) {
    return (
      <ScreenLayout>
        <VnBox className="flex-1 items-center justify-center">
          <VnLoadingSpinner />
        </VnBox>
      </ScreenLayout>
    );
  }

  return (
    <ScreenLayout>
      <VnBox className="w-full gap-2 pb-8 pt-4">
        <WorkRequirementsTitle
          rule={workRequirement.rule}
          i18nKey="native:workRequirements.nextSteps.title"
        />
        <VnText
          variant="lg"
          className="text-muted-foreground mb-4"
          i18nKey="native:workRequirements.nextSteps.description"
        />
        <WorkRequirementMembersNextSteps workRequirement={workRequirement} />
        <VnButton
          variant="outline"
          className="mt-2"
          i18nKey="native:workRequirements.recheck"
          onPress={() =>
            router.navigate({
              pathname: "/work-requirement/[id]/who",
              params: { id: workRequirement.id },
            })
          }
        />
      </VnBox>
    </ScreenLayout>
  );
};
